import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { colors, Text } from 'ic-snacks'
import RowHeaderContainer from './RowHeaderContainer'

const SubLabeledRowHeaderContainer = styled.div({
  height: '100%',
  width: '120px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  background: colors.WHITE,
  paddingLeft: '30px',
  borderRight: `1px solid ${colors.WHITE}`,
})

interface Props {
  children?: React.ReactNode
  isWeeklyView?: boolean
  label?: String
  sublabel?: String
}

const RowHeader: FunctionComponent<Props> = ({ label, sublabel, isWeeklyView, children }) => {
  if (label) {
    return (
      <SubLabeledRowHeaderContainer>
        <div>
          <Text variant="T.14" fontWeight="semiBold">
            {label}
          </Text>
        </div>
        <div>
          <Text variant="T.12">{sublabel}</Text>
        </div>
      </SubLabeledRowHeaderContainer>
    )
  }

  return (
    <RowHeaderContainer style={isWeeklyView ? { width: '120px', borderRight: 'none' } : null}>
      <Text
        variant="T.11"
        fontWeight="semiBold"
        style={{
          color: colors.GRAY_46,
          textTransform: 'uppercase',
          width: 65,
        }}
      >
        {children}
      </Text>
    </RowHeaderContainer>
  )
}

export default RowHeader
